import React from 'react'
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'

import Grid from '@material-ui/core/Grid'
import { GridList, GridListTile } from '@material-ui/core'

// @material-ui/icons
import LocationCityIcon from '@material-ui/icons/LocationCity'
import FlagIcon from '@material-ui/icons/Flag'
import NotesIcon from '@material-ui/icons/Notes'
import PeopleIcon from '@material-ui/icons/People'

// core components
import GridContainer from 'components/Grid/GridContainer.js'
import GridItem from 'components/Grid/GridItem.js'
import NavPills from 'components/NavPills/NavPills.js'

import styles from 'assets/jss/material-kit-react/views/companySections/introStyle.js'

import honor1 from 'assets/img/companyPage/honor1.png'
import honor2 from 'assets/img/companyPage/honor2.jpg'
import honor3 from 'assets/img/companyPage/honor3.png'
import honor4 from 'assets/img/companyPage/honor4.jpg'
import honor5 from 'assets/img/companyPage/honor5.jpg'
import honor6 from 'assets/img/companyPage/honor6.png'
import honor7 from 'assets/img/companyPage/honor7.jpg'
import structure from 'assets/img/companyPage/structure.png'

const requireContext = require.context('assets/img/companyPage/co', true, /^\.\/.*\.png$/)
const coImages = requireContext.keys().map(requireContext)

const useStyles = makeStyles(styles)

const imgList = [
  {
    img: honor1,
    title: 'honor1',
  },
  {
    img: honor2,
    title: 'honor2',
  },
  {
    img: honor3,
    title: 'honor3',
  },
  {
    img: honor4,
    title: 'honor4',
  },

  {
    img: honor5,
    title: 'honor5',
  },
  {
    img: honor6,
    title: 'honor6',
  },
  {
    img: honor7,
    title: 'honor7',
  },
]

export default function IntroSection() {
  const classes = useStyles()
  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <div id="navigation-pills">
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <NavPills
                alignCenter
                tabs={[
                  {
                    tabButton: '公司简介',
                    tabIcon: LocationCityIcon,
                    tabContent: (
                      <GridContainer justify="center">
                        <GridItem xs={12} sm={12} md={8}>
                          <h2 className={classes.title}>公司简介</h2>
                          <h3 className={classes.subtitle}>About Us</h3>
                          <h5 className={classes.content}>
                            江苏硕佰建筑科技有限公司由原政府平台公司江苏省绿建中心的核心团队组建，基于江苏省绿色建筑核心技术研发平台创建而来，
                            是华东地区从事节能减排业务的规模较大、专业水平较高的专家型咨询服务企业，
                            专门从事建筑科技相关技术服务和产品研发的创新型单位，
                            致力于为政府、企业、高校等提供全方位、定制化的建筑品质提升咨询服务，专业优势领域有高难度单体项目全寿命周期规划咨询、区域性绿建/海绵规模化设计。
                            咨询设计作品遍及江苏省各地市及省周边城市，近千项服务项目。
                            硕佰公司与政府机构、国内众多知名地产企业开展中长期战略合作。
                          </h5>
                        </GridItem>
                      </GridContainer>
                    ),
                  },
                  {
                    tabButton: '行业荣誉',
                    tabIcon: FlagIcon,
                    tabContent: (
                      <GridContainer justify="center">
                        <GridItem xs={12} sm={12} md={12}>
                          <h2 className={classes.title}>行业荣誉</h2>
                          <h3 className={classes.subtitle}>Corporate Honor</h3>
                          <Grid container>
                            <Grid item xs={12} sm={12} md={6}>
                              <ul>
                                <li>全国或江苏省绿色建筑创新奖（每年度均有咨询项目获奖）</li>
                                <li>入选农房建设咨询与建筑服务单位</li>
                                <li>AAA信用企业等级证书</li>
                                <li>江苏省建筑节能2016年度建筑节能之星—最具影响力人物</li>
                                <li>德国被动房资格认证证书（PHD）</li>
                                <li>LEED GA 美国绿色建筑业专业认证资格证书</li>
                                <li>标准科技创新奖（江苏省绿色建筑设计标准DGJ32/J173-2014）</li>
                              </ul>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} className={classes.listMobile}>
                              <ul>
                                <li>2017年全国绿色建筑创新奖（常州金东方颐养园）</li>
                                <li>2015年江苏绿色建筑创新奖（盐城凤鸣缇香）</li>
                                <li>2015年江苏绿色建筑创新奖（南京爱涛尚逸华府）</li>
                                <li>2018年江苏绿色建筑创新奖（江南大学数媒经管楼）</li>
                                <li>2019年江苏绿色建筑创新奖（通州市民服务中心）</li>
                                <li>标准主编《绿色机关等级评价》DB 3201T 295-2019</li>
                                <li>全国绿色建筑培训认证证书（2014首批培训认证）</li>
                              </ul>
                            </Grid>
                          </Grid>
                          <GridList className={classes.gridList}>
                            {imgList.map(tile => (
                              <GridListTile key={tile.title} className={classes.imgContainer}>
                                <img src={tile.img} alt={tile.title} className={classes.img} />
                              </GridListTile>
                            ))}
                          </GridList>
                        </GridItem>
                      </GridContainer>
                    ),
                  },
                  {
                    tabButton: '企业架构',
                    tabIcon: NotesIcon,
                    tabContent: (
                      <GridContainer justify="center">
                        <GridItem xs={12} sm={12} md={8}>
                          <h2 className={classes.title}>企业架构</h2>
                          <h3 className={classes.subtitle}>Enterprise architecture</h3>
                          <img src={structure} alt="企业架构" className={classes.imgFluid} />
                        </GridItem>
                      </GridContainer>
                    ),
                  },
                  {
                    tabButton: '合作伙伴',
                    tabIcon: PeopleIcon,
                    tabContent: (
                      <GridContainer justify="center">
                        <GridItem xs={12} sm={12} md={12}>
                          <h2 className={classes.title}>合作伙伴</h2>
                          <h3 className={classes.subtitle}>Cooperative Partner</h3>
                          <Grid container spacing={2}>
                            {coImages.map((tile, index) => (
                              <Grid item lg={2} md={3} sm={4} xs={6} key={tile} className={classes.coImages}>
                                <img src={tile} alt={index} className={classes.imgFluid} />
                              </Grid>
                            ))}
                          </Grid>
                        </GridItem>
                      </GridContainer>
                    ),
                  },
                ]}
              />
            </GridItem>
          </GridContainer>
        </div>
      </div>
    </div>
  )
}
